import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { endpoints } from '../../../../environments/environment';
import { PixKeyType } from '../models/key-type.enum';
import { PixKeyClaim } from '../models/key-claim.model';
import { BaseResult } from '../../../shared/models/base.result.model';
import { Observable } from 'rxjs/Observable';
import { PixKey } from '../models/key.model';

@Injectable()
export class PixKeysClaimService {
	private url = endpoints.pix;
	private pixKey: PixKey;

	constructor(private http: HttpClient) { }

	post(codigoChave: string, tipoChave: PixKeyType, codigoRequisicao: string): Observable<any> {
		return this.http.post<any>(`${this.url.claim}`, {
			CodigoChave: codigoChave,
			TipoChave: tipoChave,
			CodigoRequisicao: codigoRequisicao
		});
	}

	postResponse(codigoSequencial: number, resposta: boolean): Observable<any> {
		return this.http.post<any>(`${this.url.claimResponse}`, {
			CodigoSequencial: codigoSequencial,
			Resposta: resposta
		});
	}

	postCancel(codigoSequencial: number): Observable<any> {
		return this.http.post<any>(`${this.url.claim}/${codigoSequencial}/cancelar`, {});
	}

	postComplete(codigoSequencial: number): Observable<any> {
		return this.http.post<any>(`${this.url.claim}/${codigoSequencial}/concluir`, {});
	}

	getReceive(dataInicio: string, dataFim: string): Observable<BaseResult<PixKeyClaim[]>> {
		return this.http.get<BaseResult<PixKeyClaim[]>>(`${this.url.claimReceive}?dataInicio=${dataInicio}&dataFim=${dataFim}`);
	}

	getRequest(dataInicio: string, dataFim: string): Observable<BaseResult<PixKeyClaim[]>> {
		return this.http.get<BaseResult<PixKeyClaim[]>>(`${this.url.claimRequest}?dataInicio=${dataInicio}&dataFim=${dataFim}`);
	}

	setPixKey = (pixKey: PixKey) => this.pixKey = pixKey;
	getPixKey = (): PixKey => this.pixKey;

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/keys/keys-claim.service.ts